// extracted by mini-css-extract-plugin
export default {"root":"UpdateCard_root__dQqfs","header":"UpdateCard_header__J0bCa","description":"UpdateCard_description__qGJ8E","fixes":"UpdateCard_fixes__bPscM"};